import Vue from 'vue';
import VueSilentbox from 'vue-silentbox';
// eslint-disable-next-line no-unused-vars
import Components from './components'; // Load all components

// Data
import store from "../store";

export const eventBus = new Vue();

Vue.config.productionTip = false;

// Global Plugins
Vue.use(VueSilentbox);

// eslint-disable-next-line no-new
new Vue({
    el: '#app',
    delimiters: ['${', '}'],
    store,
});
